export const TEXT_INPUT = 'text';
export const OTP_INPUT = 'OTP_ENTER';
